import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { inviteExpiryFromDeadline } from '../../../../../../../../../../../models/invite-expiry';
import { WaitlistEntry } from '../../../../../../../../../../../models/scheduled-event';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../../../../utils';
import { ScheduledEventService } from '../../../../../../../../../../../services/scheduled-event/scheduled-event.service';


enum ActionList {
  modifyBookingDeadline,
  expireImmediately,
  revertToWaiting
}


@Component({
  selector: 'app-modify-pending-waitlist-entry-modal',
  templateUrl: './modify-pending-waitlist-entry-modal.component.html',
  styleUrls: ['./modify-pending-waitlist-entry-modal.component.css']
})
export class ModifyPendingWaitlistEntryModalComponent implements OnInit {

  @Input() waitlistEntry: WaitlistEntry;
  @Input() actionCompleteCallback: (result: CallbackResult) => undefined;

  public selectedAction: ActionList = null;
  public newDeadlineDate = '';
  public newDeadlineTime = '';

  public loadingSubmit = false;

  public errorMessage = '';
  public serverError: number = null;

  public ActionList = ActionList;

  constructor(
    public activeModal: NgbActiveModal,
    private scheduledEventService: ScheduledEventService
  ) {}

  ngOnInit() {
    // The server reads the submitted date/time in the entry's location zone, not UTC.
    const prefill = inviteExpiryFromDeadline(this.waitlistEntry.booking_deadline, this.waitlistEntry.time_zone);
    this.newDeadlineDate = prefill.deadlineDate;
    this.newDeadlineTime = prefill.deadlineTime;
  }

  public handleSubmit() {
    switch (this.selectedAction) {
      case ActionList.modifyBookingDeadline:
        this.handleModifyBookingDeadline();
        return
      case ActionList.expireImmediately:
        this.handleExpireImmediately();
        return
      case ActionList.revertToWaiting:
        this.handleRevertToWaiting();
        return
    }
  }

  private handleModifyBookingDeadline() {
    this.loadingSubmit = true;
    this.errorMessage = '';

    this.scheduledEventService
      .modifyWaitlistEntryBookingDeadline(
        this.waitlistEntry.id,
        this.newDeadlineDate,
        this.newDeadlineTime
      )
      .then(() => {
        this.actionCompleteCallback({
          text: this.waitlistEntry.first_name + ' ' + this.waitlistEntry.last_name + "'s booking deadline was successfully modified.",
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loadingSubmit = false;
      });
  }

  private handleExpireImmediately() {
    this.loadingSubmit = true;
    this.errorMessage = '';

    this.scheduledEventService
      .expireWaitlistEntryImmediately(this.waitlistEntry.id)
      .then(() => {
        this.actionCompleteCallback({
          text: this.waitlistEntry.first_name + ' ' + this.waitlistEntry.last_name + "'s waitlist entry was successfully expired.",
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loadingSubmit = false;
      });
  }

  private handleRevertToWaiting() {
    this.loadingSubmit = true;
    this.errorMessage = '';

    this.scheduledEventService
      .revertWaitlistEntryToWaiting(this.waitlistEntry.id)
      .then(() => {
        this.actionCompleteCallback({
          text: this.waitlistEntry.first_name + ' ' + this.waitlistEntry.last_name + "'s waitlist entry was successfully reverted to 'Waiting'.",
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loadingSubmit = false;
      });
  }
}
